import { updateLinksAttributes } from '../utils/handleAttributes';

function getHref($link) {
  const href = $link.attr('href');
  return href && href.trim() ? href.trim() : null;
}

function transformImageModule() {
  $('body.custom-cards .ImageModule:not(.custom-card-module)').each(function () {
    const $module = $(this);
    const $wrapper = $module.find('.imageModule-single__wrapper').first();
    const $image = $wrapper.find('img').first();
    const $title = $wrapper.find('h3.imageGridTitle').first();
    const titleText = $title.text().trim();

    if (!$wrapper.length || !$image.length || !$title.length || !titleText) return;

    const imageAlt = ($image.attr('alt') || '').trim();
    const url = getHref($title.find('a[href]').first()) || getHref($image.closest('a[href]'));
    const $card = url
      ? $('<a>', { class: 'card-widget-item inner-page-card', href: url })
      : $('<div>', { class: 'card-widget-item inner-page-card void-link' });
    const $imageContainer = $('<div>', { class: 'image-container' }).append($image);

    $imageContainer.append(
      $('<div>', { class: 'overlay-base', 'aria-hidden': 'true' }),
      $('<div>', { class: 'overlay-hover', 'aria-hidden': 'true' }),
    );
    $card.append($imageContainer);

    if (titleText) {
      $card.append(
        $('<div>', { class: 'card-content' }).append(
          $('<h3>', { class: 'widget-title', text: titleText }),
        ),
      );
    }

    if (url) {
      const label = titleText || imageAlt || 'More';
      updateLinksAttributes(url, label, $card);
      $card.append(
        $('<div>', { class: 'hover-content' }).append(
          $('<span>', { class: 'button alternative-btn', text: 'More' }),
        ),
      );
    }

    $module.addClass('custom-card-module');
    $wrapper.replaceWith($card);
  });
}

export default function innerPageCustomCards() {
  if (globalThis.location.pathname === '/' || !$('body').hasClass('custom-cards')) return;
  transformImageModule();
}
